import React, { useState } from 'react'
import Navbar from '../../components/Navbar/Navbar';
import PasswordInput from '../../components/PasswordInput/PasswordInput';
import { Link, useNavigate } from 'react-router-dom'
import axiosInstance from '../../Utils/axiosInstance'
import Toast from '../../components/Toast/Toast';

const Login = () => {


    const navigate = useNavigate()
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [error, setError] = useState(null);



    const handleForm = async (e) => {
        e.preventDefault();
        if (!email) {
            setError("Please Enter Email!")
            return;

        }
        if (!password) {
            setError("Please Enter Password!")
            return;
        }

        setError(" ")

        try {
            const response = await axiosInstance.post('/login', {
                email: email,
                password: password
            });
            //Successful Login 
            if (response.data && response.data.accessToken) {
                localStorage.setItem("token", response.data.accessToken);
                navigate('/dashboard')
            }


        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                setError(error.response.data.message)
            } else {
                setError("Something went wrong! Please try again later.")
            }
        }

    }

    return (
        <div className='h-100' >
            <Navbar />
            <section class="bg-gray-200">
                <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                    <div class="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
                        <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
                            <h1 class="text-xl font-bold leading-tight tracking-tight text-black md:text-2xl">
                                Sign in to your account
                            </h1>
                            <form class="space-y-4 md:space-y-6" onSubmit={handleForm} action="#">
                                <div>
                                    <label for="email" class="block mb-2 text-sm font-medium text-black">Your email</label>
                                    <input type="email" name="email" id="email" class="bg-gray-50 border border-gray-300 text-black rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder=""
                                        autoComplete='false'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required="" />
                                </div>
                                <div>
                                    <label for="password" class="block mb-2 text-sm font-medium text-black">Password</label>
                                    <PasswordInput
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                    />
                                </div>
                                {error && <p className='text-red-600 text-sm pb-1' >{error}</p>}
                                <button type="submit" class="w-full text-white bg-blue-600 hover:bg-primary-700 focus:ring-4 text-base focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Sign in</button>
                                <p class="text-sm font-light text-black">
                                    Don’t have an account yet? <Link to='/signup' class="font-bold text-blue-600 hover:underline">Sign up</Link>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default Login
